import React, { useMemo } from 'react';
import { CMSText } from './types';
import cx from '@utils/cx.util';
import { Markdown } from '@features/markdown/components/Markdown';
import { useAppSelector } from '@/store';
import Dimensions from '@features/pdp/components/Dimensions';

type Props = {
  component: CMSText;
};

const Description = ({ component }: Props) => {
  const {
    attributes: { value, cssClass = '', title, align = 'left' },
  } = component;

  const { pageDesign, details } = useAppSelector((state: any) => state.pdpItem);
  const shouldShowDimensions = useMemo(() => {
    const elements = pageDesign?.elements ?? [];
    const hasCapacity = elements.some((element) => element.elementType === 'capacity');

    if (hasCapacity) return false;

    return details?.dimensionSpecs?.sizes || details?.webImages?.dimensions;
  }, [details, pageDesign]);

  return (
    <div
      id='Description'
      className={cx('tw:my-5 tw:border-t tw:border-gray-200 tw:px-4 tw:py-5 tw:md:border-t-0', cssClass)}>
      <div className='tw:mx-auto tw:max-w-[715px]'>
        {title && (
          <p className='tw:mb-0 tw:hidden tw:text-center tw:font-title tw:text-2xl tw:font-bold tw:md:mb-5 tw:md:block'>
            {title}
          </p>
        )}
        <Markdown
          source={value}
          className={cx(
            'tw:text-left tw:text-sm tw:font-light tw:text-body tw:md:text-base tw:[&_*]:text-sm tw:md:[&_*]:!text-base tw:[&_b]:font-bold tw:[&_p]:!mb-3 tw:last:[&_p]:!mb-0',
            {
              'tw:text-center': align === 'center',
              'tw:text-right': align === 'right',
            }
          )}
        />
        {shouldShowDimensions && <Dimensions />}
      </div>
    </div>
  );
};

export default Description;
